export const reloadPage = (url: string) => {
    window.location.href = `${window.location.origin}${url}`;
};
